export default {"src":"/_next/static/media/magnifying-glass-own.4e480420.svg","height":100,"width":100};